import { useRouter } from 'next/router'
import type { ReactElement } from 'react'
import { createContext, useContext } from 'react'

type Props = {
  children: ReactElement
}

const QueryContext = createContext<object | undefined>(undefined)

const QueryProvider = ({ children }: Props) => {
  const router = useRouter()
  const initialState = router.query

  return (
    <QueryContext.Provider value={initialState}>
      {children}
    </QueryContext.Provider>
  )
}

const useQuery = () => {
  return useContext(QueryContext)
}

export { QueryProvider, useQuery }
